import * as Immutable from "immutable";
import BaseMessageRecord from "../BaseMessageRecord";

class PictureMessageRecord extends BaseMessageRecord({
  type: "picture",

  /** @memberof PictureMessageRecord# */
  altText: "",

  /** @memberof PictureMessageRecord# */
  picUrl: ""
}) {}

/**
 * Validation
 */

/**
 * @param {PictureMessageRecord} message
 * @returns {Immutable.List.<String>}
 */
PictureMessageRecord.getInvalidFields = (message) => {
  const invalidFields = new Set();

  if (message.picUrl.length <= 0) {
    invalidFields.add("picUrl");
  }

  return Immutable.List(invalidFields);
};

export default PictureMessageRecord;
